import ServicePageTemplate from "../components/ServicePageTemplate";
import Gallery from "../components/Gallery";
import { IMAGES, BEAUTIX_IG } from "../data/business";
import { SERVICES } from "../data/services";

export default function NailsPage() {
  return (
    <>
      <ServicePageTemplate
        service={SERVICES.nails}
        heroImage={IMAGES.nails}
        secondaryImage="/assets/ig/dots-almond-orange.jpg"
        breadcrumbLabel="Stylizacja paznokci"
        bullets={[
          "Autoklaw i pełna sterylizacja narzędzi po każdej klientce.",
          "E-frezarka obsługiwana z wyczuciem — bez skaleczeń, bez bólu.",
          "Wysokiej klasy produkty: NeoNail Premium, Semilac Diamond, marka premium żeli tytanowych.",
          "Realny czas zabiegu: 60–90 minut, żeby zrobić manicure hybrydowy porządnie.",
          "Doradztwo w zakresie pielęgnacji płytki między wizytami.",
        ]}
        finalSection={{ title: "Manicure hybrydowy, żelowy, tytanowy — jak w najlepszych salonach Katowic." }}
        beforeCta={<Gallery variant="bento" />}
      />
    </>
  );
}
